module.exports = __webpack_public_path__ + "static/media/Template_urgent_regular.146a2ac3.csv";